import { Button, Col, Tabs } from 'antd';
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import { InputComponent } from 'components/common/Input';
import Tab from 'components/Tab';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

import { FormButtonType } from './types';

export const TabContainerStyled = styled.div`
  height: auto;
  max-height: none;
  & .gx-signin-form .ant-form-item-control-input {
    min-height: 36px;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const InputComponentStyled = styled(InputComponent)<{ $error?: boolean; $width?: string }>`
  .ant-picker {
    ${({ $error }) => ($error ? 'border: 1px solid red;' : '')}
  }
  .ant-picker-focused {
    ${({ $error }) => ($error ? 'border: 1px solid red;' : '')}
  }
  .ant-picker-hover {
    ${({ $error }) => ($error ? 'border: 1px solid red; ' : '')}
  }
`;

export const ClearRowButtonStyled = styled(Button)`
  margin-bottom: 0;
`;

export const AddMoreButtonStyled = styled(Button)`
  width: auto;
  margin-bottom: 20px;
  margin-left: 5px;
  &.hasClearRowButton {
    margin-right: 5px;
  }
`;

export const SideFieldContainerColStyled = styled(Col)``;

export const WarningMessageStyled = styled.div`
  color: red;
  font-weight: 400;
`;

export const WarningMessageContainerRowStyled = styled(Col)`
  margin-bottom: 10px !important;
  padding: 0;
`;

export const FormActionButtonStyled = styled(ButtonWithSpinner)<{ $type?: FormButtonType }>`
  font-size: 16px;
  height: 35px;
  ${({ $type }) =>
    $type === FormButtonType.CANCEL &&
    `
      background-color: #e0e0e0;
      border: none;
      &:hover,
      &:focus {
        opacity: 0.8;
        background-color: #e0e0e0;
        color: initial;
      }
    `}
`;

export const ActionButtonStyled = styled(Button)<{
  $marginLeft?: string;
  $noBorder?: boolean;
  $danger?: boolean;
  $padding?: string;
  $isBaseAddButton?: boolean;
  $bgColor?: string;
  $marginTop?: string;
}>`
  ${({ $marginLeft }) => ($marginLeft ? `margin-left: ${$marginLeft};` : '')}
  min-width: 100%;
  margin-top: ${({ $marginTop }) => $marginTop};
  ${({ $padding }) => ($padding ? `padding: ${$padding};` : '')}
  margin-bottom: ${({ $isBaseAddButton }) => ($isBaseAddButton ? '0' : '20px !important')};
  @media (max-width: ${breakpoints.xl}) {
    margin-bottom: ${({ $isBaseAddButton }) => ($isBaseAddButton ? '0' : '12px !important')};
  }
  @media (max-width: 1080px) {
    padding: 0 10px;
  }
  @media (max-width: ${breakpoints.md}) {
    ${({ $padding }) => ($padding ? `padding: ${$padding};` : '')}
  }
  height: 36px;
  ${({ $noBorder }) => ($noBorder ? 'border: none; box-shadow: none;' : '')}
  &:hover {
    ${({ $danger }) => ($danger ? 'color: red;' : '')}
  }
  background-color: ${({ $bgColor }) => $bgColor};
`;

export const TimePickerAvailabilityContainerStyled = styled.div<{ isAvailable: boolean }>`
  display: ${({ isAvailable }) => (isAvailable ? 'block' : 'none')};
`;

export const ProfileTabs = styled(Tabs)<{ $displayMenu?: boolean }>`
  div.ant-tabs-nav {
    width: 19%;

    @media screen and (max-width: ${breakpoints.xxl}) {
      width: 25%;
    }

    @media screen and (max-width: ${breakpoints.xl}) {
      width: 33%;
    }

    @media screen and (max-width: ${breakpoints.md}) {
      width: 50%;
      margin-left: ${({ $displayMenu }) => ($displayMenu ? '0' : '-50%')};
      transition: margin 0.25s ease-in-out;
    }

    @media screen and (max-width: ${breakpoints.sm}) {
      width: 65%;
      margin-left: ${({ $displayMenu }) => ($displayMenu ? '0' : '-65%')};
      transition: margin 0.25s ease-in-out;
    }
  }

  div.ant-tabs-tabpane {
    padding: 0 !important;
  }
`;

export const CustomProfileTabs = styled(Tab)<{ $displayMenu?: boolean }>`
  & .custom-tabs-nav-bar {
    width: 19%;
    background: white;
    height: 100%;
    border-right: 1px #e9ecef solid;

    @media screen and (max-width: ${breakpoints.xxl}) {
      width: 25%;
    }

    @media screen and (max-width: ${breakpoints.xl}) {
      width: 33%;
    }

    @media screen and (max-width: ${breakpoints.md}) {
      position: absolute;
      top: 0;
      left: 0;
      width: 50%;
      transform: translateX(${({ $displayMenu }) => ($displayMenu ? '0' : '-100%')});
      transition: transform 0.25s ease-in-out;
      z-index: 16;
    }

    @media screen and (max-width: ${breakpoints.sm}) {
      position: absolute;
      top: 0;
      left: 0;
      width: 65%;
      transform: translateX(${({ $displayMenu }) => ($displayMenu ? '0' : '-100%%')});
      transition: transform 0.25s ease-in-out;
    }
  }
`;

export const TabArrowIcon = styled.i`
  font-size: 10px;
  display: flex;
  align-items: center;
`;

export const ColumnContainer = styled.div`
  div.col-wrapper {
    display: flex;
    margin-bottom: 10px;

    div.col-left {
      flex: 0.35;
      color: #545454;
      text-transform: capitalize;
      white-space: normal;
      max-width: 50px;
      overflow-wrap: break-word;
    }

    div.col-right {
      flex: 1;
      color: #8c8c8c;
      white-space: normal;
      max-width: 110px;
      overflow-wrap: break-word;
    }

    div.col-left-big {
      flex: 0.75;
      color: #545454;
      text-transform: uppercase;
      white-space: normal;
      max-width: 80px;
      overflow-wrap: break-word;
    }

    div.col-separate {
      flex: 0.1;
      max-width: 10px;
      color: #545454;
      align-items: center;
    }
  }
`;

export const BulletIcon = styled.i`
  font-size: 3px;
  margin-right: 10px;
`;

export const ProfileIcon = styled.i`
  font-size: 22px;
  display: flex;
  margin-right: 10px;
`;

export const GeneralIcon = styled.i<{ size: string }>`
  font-size: ${(props) => props.size};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LongListWrapper = styled.div<{ toggle: boolean }>`
  max-height: ${(props) => (props.toggle ? 'auto' : '230px')};
  overflow: hidden;
`;

export const ExpandButton = styled(Button)`
  width: 100%;
  background-color: transparent !important;
  outline: none !important;
  border-style: none !important;
  box-shadow: none !important;
  width: 100%;
  margin-bottom: 0;
  color: #545454;
  font-weight: normal;
  font-size: 13px;

  &:after {
    -webkit-animation: none !important;
    -moz-animation: none !important;
    -o-animation: none !important;
    -ms-animation: none !important;
    animation: none !important;
  }

  &:focus {
    color: #545454;
  }
`;

export const ExclamationIcon = styled.i`
  min-width: 17px;
  margin-left: 5px;
  position: relative;
  &::before {
    position: absolute;
    display: inline-block;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
`;

export const TabContentHeaderStyled = styled.div`
  z-index: 2;
  position: sticky;
  left: 0;
  top: 0;
`;
